import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const modules = {}
const requireModule = require.context('.', true, /\.js$/); //用來判斷載入的vuex模組規則

requireModule.keys().forEach(filename => {
  if (filename === './index.js') {
    return
  }

  //目前沒用到，先保留
  if (filename.endsWith('mutation-types.js')) {
    return
  }

  const moduleName = filename.replace(/(^\.\/|(\/index)?\.js)/g, '')
  modules[moduleName] = {
    namespaced: true,
    ...requireModule(filename)
  }
})


export default new Vuex.Store({
  modules
})
